import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { flow, map, takeWhile, filter } from 'lodash/fp';
import { isEmpty, isArray, noop } from 'lodash';

import Grid from 'components/grid';
import { ThemeContext } from 'constants/theme';

class TableItem extends PureComponent {
  static propTypes = {
    ...Grid.propTypes,
    data: PropTypes.shape({ documents: PropTypes.array }).isRequired,
    spec: PropTypes.object.isRequired,
    onGridReady: PropTypes.func,
  };

  static defaultProps = {
    ...Grid.defaultProps,
    onGridReady: noop,
  };

  constructor(props) {
    super(props);

    // Bind methods
    this.onGridReady = this.onGridReady.bind(this);
    this.autoSizeGroupColumns = this.autoSizeGroupColumns.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { meta: oldMeta = {} } = prevProps.spec;
    const { meta = {} } = this.props.spec;
    if (
      isArray(meta.sortModel) &&
      meta.sortModel !== oldMeta.sortModel &&
      this.api
    ) {
      this.api.setSortModel(meta.sortModel);
    }
  }

  /**
   * Callback that is fired when ag-grid has initialised.
   * Store the api and columnApi on this instance for later use.
   *
   * @param {Object} params - parameter object for AgGrid
   **/
  onGridReady(params) {
    this.api = params.api;
    this.columnApi = params.columnApi;

    this.autoSizeGroupColumns();
    this.props.onGridReady(params);
  }

  static contextType = ThemeContext;

  /**
   * Auto size the group columns of the grid up to max length specified in group
   **/
  autoSizeGroupColumns() {
    const { spec } = this.props;
    spec.meta = spec.meta || {};
    const {
      meta: { columnWidths = {} },
    } = spec;

    const colIds = flow(
      takeWhile(({ colId }) => colId.startsWith('group')),
      map(({ colId }) => colId),
      filter(colId => !columnWidths[colId])
    )(this.columnApi.getAllColumns());

    if (!isEmpty(colIds)) {
      // @see https://github.com/ag-grid/ag-grid-react/issues/144
      setTimeout(() => {
        this.columnApi.autoSizeColumns(colIds);
      });
    }
  }

  render() {
    const {
      className,
      padding,
      width,
      height,
      data,
      ...otherProps
    } = this.props;
    const {
      spec: { columnDefs, gridOptions, defaultColDef },
    } = this.props;

    return (
      <Grid
        {...otherProps}
        columnDefs={columnDefs}
        rowData={data.documents}
        width={width}
        height={height}
        padding={padding}
        className={className}
        onGridReady={this.onGridReady}
        onComponentStateChanged={this.onGridReady}
        defaultColDef={defaultColDef}
        theme={this.context}
        {...gridOptions}
      />
    );
  }
}

export default TableItem;
export { TableItem };
